module.exports = "/_next/static/media/c104c6ee8832b8205b4587e0d5fa1e1d.svg";